import React from 'react';
import * as S from './EmailVerified.styles';
import IconSelector from '@ibibo/icon-selector';

const EmailVerified = ({closePop, email}) => {
    return(
        <S.EmailVerifyPopWrap>
            <S.EmailVerifyPopContentWrap>
                <S.EmailVerifyPopHeadWrap>
                    <S.PopupCloseBtn onClick={closePop}>
                        <IconSelector iconKey='close' props={{fill: "#fff", width: '1rem', height: '1rem'}}/>
                    </S.PopupCloseBtn>
                </S.EmailVerifyPopHeadWrap>
                <S.EmailVerifyBodyWrap>
                    <S.EmailVerifiedTopWrap>
                        {/* <S.EmailVerifiedImgWrap>
                        
                        </S.EmailVerifiedImgWrap> */}
                        <S.EmailVerifiedInfoWrap>
                            <S.EmailVerifyMainText>E-mail verification successful</S.EmailVerifyMainText>
                            <S.EmailVerifyInfoText>Congratulations! Your myPartner account is now linked to e-mail:<strong>{email}</strong></S.EmailVerifyInfoText>
                        </S.EmailVerifiedInfoWrap>
                    </S.EmailVerifiedTopWrap>
                    {/*<S.EmailVerifiedBottomWrap>
                        <S.EmailVerifyInfoText>All the myPartner communication will be sent to {email}. This will also serve as the primary e-mail id for all your MakeMyTrip accounts.</S.EmailVerifyInfoText>
                    </S.EmailVerifiedBottomWrap>*/}
                </S.EmailVerifyBodyWrap>
            </S.EmailVerifyPopContentWrap>
        </S.EmailVerifyPopWrap>
    )
}

export default EmailVerified;